import { render, staticRenderFns } from "./LearnerMarksheetIcscAnnualPrint_2.vue?vue&type=template&id=bfd73c9a&scoped=true&style=background-color%3A%20white%3B&"
import script from "./LearnerMarksheetIcscAnnualPrint_2.vue?vue&type=script&lang=js&"
export * from "./LearnerMarksheetIcscAnnualPrint_2.vue?vue&type=script&lang=js&"
import style0 from "./LearnerMarksheetIcscAnnualPrint_2.vue?vue&type=style&index=0&id=bfd73c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd73c9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
